import React, {useEffect} from 'react';
import {Route, Switch, NavLink, useRouteMatch, Redirect} from 'react-router-dom';

import {
  CashBoxes,
  PreciousMetals,
  Affiliates,
  JewelNames,
  Reasons,
  DepartmentEdit,
  DepartmentAdd,
  CarNames,
} from '..';
import {permissionsAccess} from '../../helpers/common';

import './handbooks.scss';
import '../../assets/styles/components/_tables.scss';
import {useSelector} from "react-redux";
import {UpdatingDirectories} from "../UpdatingDirectories/UpdatingDirectories";
import Loader from "../JewelNames/Loader/Loader";
import {McsIntegration} from "../McsIntegration/McsIntegration";
import DebtToIncomeRatio from '../DebtToIncomeRatio/DebtToIncomeRatio';


const Handbooks = ({setTitlePage}) => {
  const routeMatch = useRouteMatch();
  const url = routeMatch.url;
  const showHandbookLinks = permissionsAccess("action.branch.list") && permissionsAccess("action.cashbox.list");
  const showMetalsNamesLynks = permissionsAccess("action.purities.details") || permissionsAccess("action.words.details")
  const showBranchLink = permissionsAccess("action.branch.list");
  const showCarsLink = permissionsAccess("handbooks.car.names");
  const showDtiRatio = permissionsAccess("debt_load.config.list");
  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);

  let entityNavLink = [
    {to: '/handbooks/departments', component: <CashBoxes/>, text: 'Подразделения'},
    {to: '/handbooks/metals', component: <PreciousMetals/>, text: 'Драгоценные металлы'},
    {to: '/handbooks/dti-ratio', component: <DebtToIncomeRatio/>, text: 'ПДН'},
    {to: '/handbooks/jewelNames', component: <JewelNames/>, text: 'Наименования'},
    {to: '/handbooks/reasons', component: <Reasons/>, text: 'Основания'},
  ];

  const insertIndex = (previousLink) => {
    return entityNavLink.findIndex(item => item.text === previousLink) + 1;
  }

  if (accessFeatures['branches']) {
    entityNavLink.splice(insertIndex('Подразделения'), 0, {to: '/handbooks/affiliates', component: <Affiliates/>, text: 'Филиалы'});
  }

  if (accessFeatures['cars.feature']) {
    entityNavLink.splice(insertIndex('Наименования'), 0, {to: '/handbooks/carNames', component: <CarNames/>, text: 'Наименования авто'});
  }

  if (accessFeatures['elastic.load.file']) {
    entityNavLink.splice(insertIndex('Основания'), 0, {to: '/handbooks/UpdatingDirectories', component: <UpdatingDirectories/>, text: 'Обновление справочников'});
  }

  if (accessFeatures['mcs.migration']) {
    entityNavLink.push(
      {to: '/handbooks/mcsIntegration', component: <McsIntegration/>, text: 'Импорт из базы МКС'}
    );
  }

  const entityRoute = [
    {to: '/handbooks/department', component: <DepartmentAdd/>, text: ''},
    {to: '/handbooks/department/:id', component: <DepartmentEdit successFeatures={accessFeatures}/>, text: ''},
  ];

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Справочники');
  }, [isLoadingConfiguration]);

  return (
    <main className="app-content">
      {isLoadingConfiguration ?
        (<div className="content-inner">
          <Loader pageRange={1}/>
        </div>) :
        (<>
          {!accessFeatures['title.header_section'] &&
            (<div className="content-header">
              <div className="content-header-breadcrumbs">
                <h1>Справочники</h1>
              </div>
            </div>)}
          <div className="content-inner">
            <div className="content-inner-data">
              <div className="content-tabs">
                {entityNavLink.map((i) => {
                  if (showCarsLink && (i.to === '/handbooks/carNames' && accessFeatures['cars.feature'])) {
                    return (
                      <NavLink
                        key={i.to}
                        className={'content-tabtrigger button-white' + (url === i.to ? ' active' : '')}
                        to={i.to}
                      >
                        {i.text}
                      </NavLink>
                    );
                  }
                  if (showHandbookLinks && (i.to !== '/handbooks/carNames' || !accessFeatures)) {
                    return (
                      <NavLink
                        key={i.to}
                        className={'content-tabtrigger button-white' + (url === i.to ? ' active' : '')}
                        to={i.to}
                      >
                        {i.text}
                      </NavLink>
                    );
                  }
                  if (showMetalsNamesLynks && (i.to === '/handbooks/metals' || i.to === '/handbooks/jewelNames')) {
                    return (
                      <NavLink
                        key={i.to}
                        className={'content-tabtrigger button-white' + (url === i.to ? ' active' : '')}
                        to={i.to}
                      >
                        {i.text}
                      </NavLink>
                    );
                  }
                  if (showDtiRatio && (i.to === '/handbooks/dti-ratio')) {
                    return (
                      <NavLink
                        key={i.to}
                        className={'content-tabtrigger button-white' + (url === i.to ? ' active' : '')}
                        to={i.to}
                      >
                        {i.text}
                      </NavLink>
                    );
                  }
                  if (showBranchLink && i.to === '/handbooks/affiliates') {
                    return (
                      <NavLink
                        key={i.to}
                        className={'content-tabtrigger button-white' + (url === i.to ? ' active' : '')}
                        to={i.to}>
                        {i.text}
                      </NavLink>
                    );
                  }
                  return null;
                })}
              </div>
              <Switch>
                {entityRoute.concat(entityNavLink).map((i) => {
                  if (showHandbookLinks) {
                    return <Route key={i.to} path={i.to} render={() => i.component} exact/>;
                  } else {
                    return (
                      <Route
                        key={i.to}
                        path={i.to}
                        render={() => {
                          if (i.to.includes('/handbooks/department') && showBranchLink) {
                            return <Redirect to="/handbooks/affiliates"/>;
                          }
                          if (i.to.includes('/handbooks/department') && showMetalsNamesLynks) {
                            return <Redirect to="/handbooks/metals"/>;
                          }
                          return i.component;
                        }}
                        exact
                      />
                    );
                  }
                })}
              </Switch>
            </div>
          </div>
        </>)
      }

    </main>
  );
};

export default Handbooks;
